import styled from "styled-components/macro";

export const StyleGuideSecondaryButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  padding: 0 16px;
  box-sizing: border-box;
  border: 2px solid var(--primary-cta-high-contrast);
  border-radius: 10px;
  background: transparent;
  color: var(--primary-cta-high-contrast);
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  cursor: pointer;
  transition:
    background 160ms ease,
    border-color 160ms ease,
    color 160ms ease,
    opacity 160ms ease;

  svg path {
    fill: currentColor;
  }

  &:hover,
  &:focus-visible {
    background: var(--primary-cta-translucent);
    outline: none;
  }

  &:disabled {
    border-color: var(--grey-3);
    background: transparent;
    color: var(--grey-2);
    opacity: 0.55;
    cursor: not-allowed;
  }

  &:disabled:hover {
    background: transparent;
  }
`;
